import hexRgb, { RgbaObject } from 'shared/util/hexrgb';
import { rgbaToHex } from 'shared/util/hexrgb';

/**
 * Calculates the luminance of a color.
 * @param rgba - The RGBA color array.
 * @returns The luminance value.
 */
export const calculateLuminance = (rgba: RgbaObject | string | number[]) => {
  return (rgba[0] * 299 + rgba[1] * 587 + rgba[2] * 114) / 1000;
};

/**
 * Determines the appropriate text color (black or white) based on the luminance of the background color.
 * @param value - The background color in hex or rgba format.
 * @returns 'black' or 'white' based on the luminance.
 */
export const textColor = (value: string) => {
  let rgba: string | number[] | RgbaObject;
  if (value && (value.startsWith('#') || value.startsWith('rgba'))) {
    rgba = hexRgb(value, { format: 'array' });
    if (value.startsWith('rgba') && rgba[3] < 0.5) {
      return 'black';
    }
  } else {
    return 'black';
  }
  const luminance = calculateLuminance(rgba);
  return luminance >= 128 ? 'black' : 'white';
};

/**
 * Maps edit color link IDs to theme keys.
 * @param editColorsLinkId - The ID of the edit colors link.
 * @returns The corresponding theme key.
 */
export const determineThemeKeyFromEditColorsLinkId = (
  editColorsLinkId: string | undefined
): string => {
  const themeKeyMap: Record<string, string> = {
    'edit-colors-link-1': 'customTheme1',
    'edit-colors-link-2': 'customTheme2',
    'edit-colors-link-3': 'customTheme3',
  };

  return themeKeyMap[editColorsLinkId ?? ''] || '';
};

/**
 * Converts an RGBA or HEX color to HEX format.
 * @param color - The color in RGBA or HEX format.
 * @returns The color in HEX format.
 */
export const convertToHex = (color: string): string => {
  return color.startsWith('rgb') ? rgbaToHex(color) : color;
};
